import { App as AntdApp } from 'antd';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { IoProvider } from 'socket.io-react-hook';

import dayjs from '@seolens/date-manager';
import countriesI18 from 'i18n-iso-countries';
import i18nUK from 'i18n-iso-countries/langs/uk.json';

import 'antd/dist/reset.css';

import { App } from './App';
import { AuthProvider, ErrorBoundaryLayout, NetworkErrorProvider } from './common/layouts';

dayjs.tz.setDefault('Europe/Kiev');

countriesI18.registerLocale(i18nUK);

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <ErrorBoundaryLayout>
    <BrowserRouter>
      <AntdApp>
        <NetworkErrorProvider>
          <IoProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </IoProvider>
        </NetworkErrorProvider>
      </AntdApp>
    </BrowserRouter>
  </ErrorBoundaryLayout>,
);
